<template>
<el-dialog  title="货物" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="jiahuoFlag" width="95%" center>
  <div>
  <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
    <el-form-item label="货物类型 :" prop="productType">
      <div>{{goodform.productTypeName}}</div>
    </el-form-item>
    <el-form-item label="计量单位 :" prop="measuringUnit">
       <div>{{goodform.measuringUnit}}</div>
    </el-form-item>
    <el-form-item label="重量(吨):"  prop="weight" :rules="goodform.measuringUnit=='吨'||goodform.dun?rules.weight:[{required: false}]" >
      <el-input  placeholder="" v-number-input.float="3" maxlength="8"  v-model="goodform.weight"
      class="width2" :readonly="goodform.goodsList.length>0"  @change="orderWeightFn($event,'吨')"></el-input>
    </el-form-item>
    <el-form-item label="数量(件):" prop="orderNumber" :rules="goodform.measuringUnit=='件'||goodform.jian?rules.orderNumber:[{required: false}]">
      <el-input  placeholder="" v-number-input.float="0" maxlength="8"  v-model="goodform.orderNumber"
      class="width2" :readonly="goodform.goodsList.length>0"  @change="orderWeightFn($event,'件')"></el-input>
    </el-form-item>
    <el-form-item label="体积(方):" prop="volumn" :rules="goodform.measuringUnit=='方'||goodform.fang?rules.volumn:[{required: false}]" >
      <el-input  placeholder="" v-number-input.float="3" maxlength="8"  v-model="goodform.volumn"
      class="width2" :readonly="goodform.goodsList.length>0"  @change="orderWeightFn($event,'方')"></el-input>
    </el-form-item>
    <div class="box1" v-if="goodform.goodsList.length>0">
      <div >
        <span style="padding-right:8px" >
          <el-button  v-if="goodform.goodsList.length==0||(goodform.goodsList.length>0&&goodform.goodsList[0].customerName)"
          type="primary" size="mini" @click="guanlianFN">关联货物</el-button>
        </span>
        <el-button v-if="goodform.goodsList.length>0&&!goodform.goodsList[0].customerName"
        type="primary" size="mini"   @click="addHWFN">添加货物</el-button>
        <el-button type="primary" size="mini"  v-if="goodform.goodsList.length>0&&!goodform.goodsList[0].customerName"   @click="daoruFN">导入货物</el-button>
        <el-button type="primary" size="mini"  v-if="goodform.goodsList.length>0&&!goodform.goodsList[0].customerName"  @click="xiazai">下载模板</el-button>
        <el-form-item label="" >
          <p class="margin0" v-if="goodform.goodsList.length>0">已选:
            <span v-if="goodform.weight"><span class="red">{{goodform.weight}}</span>吨</span>
            <span v-if="goodform.weight&&(goodform.orderNumber||goodform.volumn)">/</span>
            <span v-if="goodform.orderNumber"><span class="red">{{goodform.orderNumber}}</span>件</span>
            <span v-if="goodform.orderNumber&&goodform.volumn">/</span>
            <span v-if="goodform.volumn"><span class="red">{{goodform.volumn}}</span>方</span>
          </p>
        </el-form-item>
      </div>
    </div>
    <div style="padding: 0 16px 0 16px;" v-if="goodform.goodsList.length>0">
      <el-table height="300px" size="mini" ref="tabref" :data="goodform.goodsList" style="width:100%" border center>
        <el-table-column type="index"  label="序号" width="60"></el-table-column>
        <el-table-column label="操作"  width="200">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" v-if="scope.row.orderGoodsState!=1" @click="delFn(scope.$index)">删除</el-button>
              <span v-else>-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="orderGoodsState" label="生成运单">
          <template scope="scope">
            <div>
             <span>{{['否','是'][scope.row.orderGoodsState]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true"  prop="customerName"
          label="货权客户" min-width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号"
          min-width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)"
          min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="数量(件)"
          min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="volumn" label="体积(方)"
          min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名"
          min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质"
          min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格"
          min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="货位"
           min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号"
          min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号"
          min-width="120"></el-table-column>
      </el-table>
    </div>
    <!-- 添加货物 -->
    <el-dialog  title="添加货物" :close-on-click-modal="false" :close-on-press-escape="false"  @close="dialogVisible = false"
    :visible.sync="dialogVisible" width="1300px" center append-to-body>
      <div>
        <div>货物类型:{{goodform.productTypeName}}&nbsp; &nbsp;&nbsp;  计量单位：{{goodform.measuringUnit}}</div>
        <el-form :inline="true" ref="dataFrom"  :model="dataFrom" :rules="rules"  class="demo-form-inline jiaoyan" size="mini">
         <el-table :data="dataFrom.goodsList"  ref="table"   bordersize="mini"  style="width: 100%" max-height="500px"  center border v-if="dialogVisible">
          <el-table-column type="index"  label="序号" width="60"></el-table-column>
          <el-table-column label="操作"  width="100">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="addGoodFn(scope.row)">新增</el-button>
                <el-button type="text" size="mini" @click="delGoodFn(scope.$index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
           <el-table-column label="捆包号" min-width="120">
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.cargoBarcode'" :key="scope.$index" :rules="rules.cargoBarcode" class="table_error">
                  <el-input placeholder="" maxlength="20"
                    v-model.trim="dataFrom.goodsList[scope.$index].cargoBarcode" ></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="重量"  min-width="120">
            <template slot="header" >
              <div><span class="red" v-if="goodform.measuringUnit=='吨'">*</span>重量(吨)</div>
            </template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.weight'" :key="scope.$index" :rules="goodform.measuringUnit=='吨'?rules.weight:[{required: false}]"  class="table_error">
                  <el-input placeholder="" maxlength="10" v-number-input.float="3"
                    v-model.trim="dataFrom.goodsList[scope.$index].weight" @change="weightFn($event,scope.$index,'吨')"></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数量"  min-width="120">
            <template slot="header" >
              <div><span class="red" v-if="goodform.measuringUnit=='件'">*</span>数量(件)</div>
            </template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.number'" :key="scope.$index" :rules="goodform.measuringUnit=='件'?rules.number:[{required: false}]" class="table_error">
                  <el-input placeholder="" maxlength="10" v-number-input.float="0"
                    v-model.trim="dataFrom.goodsList[scope.$index].number" @change="weightFn($event,scope.$index,'件')"></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="体积"  min-width="120">
            <template slot="header" >
              <div><span class="red" v-if="goodform.measuringUnit=='方'">*</span>体积(方)</div>
            </template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.volumn'" :key="scope.$index" :rules="goodform.measuringUnit=='方'?rules.volumn:[{required: false}]"  class="table_error">
                  <el-input placeholder="" maxlength="10" v-number-input.float="3"
                    v-model.trim="dataFrom.goodsList[scope.$index].volumn" @change="weightFn($event,scope.$index,'方')"></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="品名" min-width="120">
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.productName'" :key="scope.$index"  class="table_error">
                  <el-input placeholder="" maxlength="20"
                    v-model.trim="dataFrom.goodsList[scope.$index].productName" ></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="材质" min-width="120">
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.model'" :key="scope.$index"  class="table_error">
                  <el-input placeholder="" maxlength="20"
                    v-model.trim="dataFrom.goodsList[scope.$index].model" ></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="规格" min-width="120">
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.specification'" :key="scope.$index"  class="table_error">
                  <el-input placeholder="" maxlength="20"
                    v-model.trim="dataFrom.goodsList[scope.$index].specification" ></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
           <el-table-column label="合同号" min-width="120">
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.contractNumber'" :key="scope.$index"  class="table_error">
                  <el-input placeholder="" maxlength="20"
                    v-model.trim="dataFrom.goodsList[scope.$index].contractNumber" ></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="合约号" min-width="120">
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.agreementNumber'" :key="scope.$index" class="table_error">
                  <el-input placeholder="" maxlength="20"
                    v-model.trim="dataFrom.goodsList[scope.$index].agreementNumber" ></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
         </el-table>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFN">提交</el-button>
      </span>
    </el-dialog>
    <el-dialog title="关联货物" :visible.sync="addVisible" :close-on-click-modal="false" width="90%"
      center append-to-body>
      <!--输入框-->
      <div class="guanLianBox-input">
        <el-form :inline="true" :model="formData" class="demo-form-inline" size="mini"  ref="formData">
          <div class="box">
            <el-form-item label="捆包号:" class="item1">
              <el-input type="textarea" v-model="formData.cargoBarcodes" placeholder="请输入" size="mini"
                style="width:150px;vertical-align:top;"></el-input>
            </el-form-item>
            <el-form-item label="规格:" label-width="70px">
              <el-input v-model="formData.specification" placeholder="请输入" size="mini" style="width:135px;"></el-input>
            </el-form-item>
            <el-form-item label="材质:">
              <el-input v-model="formData.model" placeholder="请输入" size="mini" style="width:135px;"></el-input>
            </el-form-item>
            <el-form-item label="产地:">
              <el-input v-model="formData.steelMillName" placeholder="请输入" size="mini" style="width:135px;"></el-input>
            </el-form-item>
            <el-form-item label="合约号:">
              <el-input v-model="formData.agreementNumber" placeholder="请输入" size="mini" style="width:135px;"></el-input>
            </el-form-item>
            <el-form-item label="宽度:">
              <el-select size="mini" v-model="formData.widthWhere" placeholder="请选择" style="width:120px;">
                <el-option label="全部" value=""></el-option>
                <el-option label="大于等于" value="1"></el-option>
                <el-option label="小于等于" value="3"></el-option>
                <el-option label="等于" value="2"></el-option>
              </el-select>
              <el-input v-model="formData.width" v-number-input.float="0" placeholder="请输入" size="mini"
                style="width:80px;"></el-input>
            </el-form-item>
            <el-form-item label="锁定状态:">
              <el-select size="mini" v-model="formData.lockState" style="width:136px" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="未锁定" value="0"></el-option>
                <el-option label="已锁定" value="1"></el-option>
                <el-option label="加工锁定" value="2"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="searchBtnBox">
            <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi">重置</el-button>
          </div>
        </el-form>
      </div>
      <div class="guanLianBox-Table">
        <el-table size="mini" ref="guanlianTable" :data="relevanceTableData" style="width:100%" height="40vh"
          :header-cell-style="{ background: '#F5F5F5', color: 'black' }"  @row-click="handleRowClick" border center
          bordersize="mini">
          <el-table-column type="selection" align="center" fixed width="60" :selectable="checkSelectable"></el-table-column>
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="lockState" label="锁定状态" align="center" width="100">
            <template slot-scope="scope">
              <!-- {{ scope.row.lockState == "0" ? "未锁定" : scope.row.lockState == "1": '已锁定' ? '加工锁定' }} -->
              <div >
                <span v-if="scope.row.lockState == 0">未锁定</span>
                <span v-if="scope.row.lockState == 1">已锁定</span>
                <span v-if="scope.row.lockState == 2">加工锁定</span>
              </div>
            </template>

          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center"
            width="250"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
            width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名" align="center"
            width="145"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
            width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center"
            width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量（吨）" align="center"
            width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"
            width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="货位" align="center"
            width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="vehicleNumber" label="车船号" align="center"
            width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号" align="center"
            width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center"
            width="200"></el-table-column>
        </el-table>
        <!--分页-->
        <div class="pags" style="text-align: right;">
          <el-pagination background @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize"
            :page-sizes="[10, 50, 100, 500]" layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange" :total="total"></el-pagination>
        </div>
      </div>
      <div style="width:158px;margin:20px auto;">
        <el-button @click="addVisible=false">取消</el-button>
        <el-button type="primary" @click="guanlianOk" >确定</el-button>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <importC v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
  </el-form>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button  @click="closeDialog">取消</el-button>
    <el-button type="primary" @click="saveFn">确定</el-button>
  </span>
</el-dialog>
</template>
<script>
import { getDictionaryDetailList, importOrderGoods, getWhOutstockPlanCargoList, checkRequiredFields, getOrderInfo, addGoods } from '@/api/newTMS'
import { toFixed } from '@/utils/util'
import importC from '@/components/import.vue'
export default {
  components: {
    importC
  },
  name: 'addgood',
  props: {
    jiahuoFlag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dialogVisible: false,
      isZhankai: false,
      dataFrom: {
        goodsList: [{}]
      },
      goodform: { ...this.rowData },
      rules: {
        // cargoBarcode: [
        //   { required: true, message: ' ', trigger: 'blur' }
        // ],
        weight: [
          { required: true, message: '请输入重量', trigger: 'blur' }
        ],
        volumn: [
          { required: true, message: '请输入体积', trigger: 'blur' }
        ],
        orderNumber: [
          { required: true, message: '请输入数量', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '请输入数量', trigger: 'blur' }
        ]

        // unitPrice: [
        //   { required: true, message: '请输入价格', trigger: 'blur' }
        // ],
      },
      allWeight: 0,
      importDialog: false,
      addVisible: false, // 关联货物
      pageNo: 1,
      pageSize: 10,
      formData: { cargoBarcodes: '' },
      total: 0,
      relevanceTableData: [],
      delgoodIds: [],
      oldWeight: this.rowData.stowageWeight,
      oldNumber: this.rowData.stowageNumber,
      oldVolumn: this.rowData.stowageVolumn

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    getOrderInfo({ orderBusinessId: this.rowData.orderBusinessId }).then(res => {
      this.$set(this.goodform, 'goodsList', res.goodslist)
    })
    this.getflagFn()
  },
  methods: {
    // 保存
    saveFn () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      const newArr = this.goodform.goodsList.map(item => item.cargoBarcode)
      const arrSet = new Set(newArr)
      if (arrSet.size !== newArr.length) {
        this.$alert('捆包号不能重复', '系统提示')
        loading.close()
        return
      }
      if (this.goodform.weight && this.goodform.weight < this.oldWeight) {
        this.$alert('输入的重量需要大于已配载量', '系统提示')
        loading.close()
        return
      }
      if (this.goodform.orderNumber && this.goodform.orderNumber < this.oldNumber) {
        this.$alert('输入的数量需要大于已配载量', '系统提示')
        loading.close()
        return
      }
      if (this.goodform.volumn && this.goodform.volumn < this.oldVolumn) {
        this.$alert('输入的体积需要大于已配载量', '系统提示')
        loading.close()
        return
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          let arr = []
          this.goodform.goodsList.forEach(item => {
            if (!item.orderGoodsRelId) {
              arr.push(item)
            }
          })
          // if (this.goodform.goodsList.length > 0 && arr.length === 0) {
          //   this.$alert('请先选择要添加的货物', '系统提示')
          //   return
          // }
          addGoods({
            orderBusinessId: this.rowData.orderBusinessId,
            goodsList: arr,
            volumn: this.goodform.volumn ? this.goodform.volumn : 0,
            weight: this.goodform.weight ? this.goodform.weight : 0,
            number: this.goodform.orderNumber ? this.goodform.orderNumber : 0,
            deleteOrderGoodsRelIds: this.delgoodIds
          }).then(res => {
            loading.close()
            this.$parent.searchFn()
            this.$emit('update:jiahuoFlag', false)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 货物重量改变
    orderWeightFn (e, danwei) {
      if (e != '' && Number(e) === 0) {
        this.$alert('输入的值不能为0', '系统提示')
        if (danwei == '吨') {
          this.$set(this.goodform, 'weight', '')
        } else if (danwei == '件') {
          this.$set(this.goodform, 'orderNumber', '')
        } else if (danwei == '方') {
          this.$set(this.goodform, 'volumn', '')
        }
      } else {
        if (danwei == '吨') {
          if (this.goodform.weight && this.goodform.weight < this.oldWeight) {
            this.$alert('输入的重量需要大于已配载量', '系统提示')
            this.$set(this.goodform, 'weight', '')
          }
        } else if (danwei == '件') {
          if (this.goodform.orderNumber && this.goodform.orderNumber < this.oldNumber) {
            this.$alert('输入的数量需要大于已配载量', '系统提示')
            this.$set(this.goodform, 'orderNumber', '')
          }
        } else if (danwei == '方') {
          if (this.goodform.volumn && this.goodform.volumn < this.oldVolumn) {
            this.$alert('输入的体积需要大于已配载量', '系统提示')
            this.$set(this.goodform, 'volumn', '')
          }
        }
      }
      this.orderWightFuzhi()
    },
    orderWightFuzhi () {
      if (this.goodform.measuringUnit == '吨') {
        this.$set(this.goodform, 'orderWeight', this.goodform.weight)
      } else if (this.goodform.measuringUnit == '件') {
        this.$set(this.goodform, 'orderWeight', this.goodform.orderNumber)
      } else if (this.goodform.measuringUnit == '方') {
        this.$set(this.goodform, 'orderWeight', this.goodform.volumn)
      }
    },
    // 弹框货物重量改变
    weightFn (e, index, danwei) {
      if (e != '' && Number(e) === 0) {
        this.$alert('输入的值不能为0', '系统提示')
        if (danwei == '吨') {
          this.$set(this.dataFrom.goodsList[index], 'weight', '')
        } else if (danwei == '件') {
          this.$set(this.dataFrom.goodsList[index], 'number', '')
        } else if (danwei == '方') {
          this.$set(this.dataFrom.goodsList[index], 'volumn', '')
        }
      }
    },
    // 关联货物
    guanlianFN () {
      if (this.goodform.productType) {
        this.addVisible = true
        // this.chaxun()
      } else {
        this.$alert('请先选择货物类型', '系统提示')
      }
    },
    guanlianOk () {
      let selectData = this.$refs.guanlianTable.selection
      let arr = []
      selectData.forEach(item => {
        let json = this.goodform.goodsList.filter(i => i.cargoBarcode == item.cargoBarcode)
        if (json.length == 0) {
          arr.push(item)
        }
      })
      this.goodform.goodsList = this.goodform.goodsList.concat(arr)
      this.addVisible = false
      this.isZhankai = true
      this.getAllWeight()
    },
    // 选择数据
    selectGoods (selection) {
    },
    handleRowClick (row, column, event) {
      // this.$refs.tabref.toggleRowSelection(row)
    },
    checkSelectable (row) {
      let json = this.goodform.goodsList.filter(i => i.cargoBarcode == row.cargoBarcode)
      if (json.length == 0) {
        return true
      } else {
        return false
      }
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.chaxun()
    },
    chaxun () {
      this.formData.cargoBarcodes = this.formData.cargoBarcodes.replace(/\n/g, ',')
      this.formData.cargoBarcodes = this.formData.cargoBarcodes.split(',').filter(item => item != '').join(',')
      getWhOutstockPlanCargoList(
        {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          tenantCode: '002',
          productTypeName: this.goodform.productTypeName,
          ...this.formData,
          billIdIsNull: '1'
        }
      ).then(res => {
        console.log(res)
        this.relevanceTableData = res.list
        this.total = res.total
      }).catch(error => {
        this.$message({ message: error.message, type: 'error' })
      })
    },
    chongzhi () {
      this.formData = {
        cargoBarcodes: '',
        specification: '',
        steelMillName: '',
        widthWhere: '',
        width: '',
        model: ''
      }
      this.chaxun()
    },
    //= ========关联货物结束==========
    // 弹框添加货物
    addGoodFn (row) {
      let json = { ...row }
      this.dataFrom.goodsList.push(json)
    },
    // 弹框删除货物
    delGoodFn (index) {
      this.dataFrom.goodsList.splice(index, 1)
    },
    // 弹出框保存
    saveFN () {
      this.$refs.dataFrom.validate((valid) => {
        if (valid) {
          let gooArr = [...this.goodform.goodsList]
          let goodArr1 = gooArr.concat(this.dataFrom.goodsList)
          const newArr = goodArr1.map(item => item.cargoBarcode)
          const arrSet = new Set(newArr)
          if (arrSet.size === newArr.length) {
            this.dataFrom.goodsList = [{}]
            this.goodform.goodsList = goodArr1
            this.dialogVisible = false
            this.isZhankai = true
            this.getAllWeight()
          } else {
            this.$alert('捆包号不能重复', '系统提示')
          }
        }
      })
    },
    // 外面添加货物
    addHWFN () {
      if (this.goodform.productType && this.goodform.measuringUnit) {
        this.dialogVisible = true
      } else {
        this.$alert('请先选择货物类型和单位', '系统提示')
      }
    },
    // 货物类型改变
    HWLCchange (e) {
      let json = this.HWlist.filter(item => item.itemNo == e)
      this.$set(this.goodform, 'productTypeName', json[0].showName)
      // this.goodform.dun = json[0].ext1
      // this.goodform.jian = json[0].ext2
      // this.goodform.fang = json[0].ext3
    },
    // 导入货物
    daoruFN () {
      this.importDialog = true
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      importOrderGoods(formData).then(res => {
        loading.close()
        this.importDialog = false
        this.goodform.goodsList = this.goodform.goodsList.concat(res)
        this.isZhankai = true
        this.getAllWeight()
      }).catch(error => {
        console.log(error)
        let arr = JSON.parse(error.message)
        let msgArr = []
        arr.forEach(item => {
          msgArr.push(item.excMsg)
        })
        this.$message({
          showClose: false,
          message: msgArr.toString() + ',不能导入。',
          duration: 3000,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    destroy () {
      this.importDialog = false
    },
    xiazai () {
      window.open(
        'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/template/tms/%E8%B4%A7%E7%89%A9%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
      )
    },
    // 删除
    delFn (index) {
      if (this.goodform.goodsList[index].orderGoodsRelId) {
        this.delgoodIds.push(this.goodform.goodsList[index].orderGoodsRelId)
      }
      this.goodform.goodsList.splice(index, 1)
      this.getAllWeight()
    },
    // 计算货物重量
    getAllWeight () {
      this.allWeight = 0
      let allNumber = 0
      let allvolumn = 0
      this.goodform.goodsList.forEach(item => {
        if (item.weight) {
          this.allWeight = (this.allWeight * 1000 + item.weight * 1000) / 1000
        }
        if (item.number) {
          allNumber = (allNumber * 1000 + item.number * 1000) / 1000
        }
        if (item.volumn) {
          allvolumn = (allvolumn * 1000 + item.volumn * 1000) / 1000
        }
      })
      this.$set(this.goodform, 'weight', this.allWeight)
      this.$set(this.goodform, 'orderNumber', allNumber)
      this.$set(this.goodform, 'volumn', allvolumn)
      this.orderWightFuzhi()
    },
    // 判断吨件方是否必填
    getflagFn () {
      if (this.goodform.payee && this.goodform.kilometres && this.goodform.productTypeName) {
        checkRequiredFields({
          itemNo: this.goodform.payee,
          showName: this.goodform.productTypeName,
          kilometres: this.goodform.kilometres
        }).then(res => {
          this.$set(this.goodform, 'dun', res.weight)
          this.$set(this.goodform, 'jian', res.number)
          this.$set(this.goodform, 'fang', res.volumn)
        })
      }
    },
    closeDialog () {
      this.$emit('update:jiahuoFlag', false)
    }
  },
  computed: {
    listenChange () {
      const { productType, payee, kilometres } = this.goodform
      return { productType, payee, kilometres }
    }
  },
  watch: {
    listenChange () {
      this.getflagFn()
    }
  },
  destroyed () {
  }

}
</script>

<style scoped lang='less'>

</style>
